import { render, staticRenderFns } from "./StorageRecords.vue?vue&type=template&id=7dc8e104&scoped=true&"
import script from "./StorageRecords.vue?vue&type=script&lang=js&"
export * from "./StorageRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8e104",
  null
  
)

export default component.exports